import React from 'react';

import Icon from '../Icon/Icon';

const FirmwareUpdateIcon = (props) => {
    return (
        <Icon width='64' height='64' fill='none' {...props}>
            <path
                d='M20.0816 9.76714C23.8447 9.43792 27.2605 11.5286 28.7951 14.7493L25.7294 49.2454C25.6639 49.9822 25.7672 50.698 26.0077 51.3503C25.3003 51.6074 24.5486 51.7799 23.7633 51.8486L21.1337 52.0786C20.115 52.1677 19.1242 52.0597 18.1996 51.7864C17.7993 51.668 17.5319 51.3021 17.4954 50.8863L17.4624 50.5089C15.0893 49.8783 13.2522 47.8201 13.0257 45.2329L10.6764 18.3804C10.45 15.7929 11.9015 13.4452 14.1293 12.4122L14.0761 11.8032C14.0397 11.3872 14.2395 10.9807 14.6132 10.7945C15.4764 10.3648 16.4333 10.0863 17.452 9.9972L20.0816 9.76714ZM31.7635 42.3143C32.0845 45.9838 30.104 49.3221 27.0189 50.9089C26.8489 50.4223 26.7769 49.8899 26.8258 49.3397L29.6234 17.853L31.7635 42.3143Z'
                fill='#393E44'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M12.8449 12.8761C13.2313 12.6051 13.6568 12.384 14.1128 12.2231L17.479 50.699C17.002 50.6197 16.5445 50.4758 16.1169 50.276L12.8449 12.8761Z'
                fill='#FFFDFB'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M15.1613 39.3499L12.5312 39.58L12.3778 37.8267L15.0079 37.5966L15.1613 39.3499Z'
                fill='#00D1D2'
            />
            <path
                d='M30.0845 12.6673C30.2645 10.6419 32.0106 9.13784 33.9846 9.30788L50.4258 10.7241C52.3998 10.8942 53.8541 12.6739 53.6741 14.6993L50.4155 51.372C50.2355 53.3974 48.4894 54.9014 46.5154 54.7314L30.0742 53.3151C28.1002 53.1451 26.6459 51.3654 26.8259 49.34L30.0845 12.6673Z'
                fill='#393E44'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M35.8021 48.635C35.8584 48.0021 36.4117 47.5328 37.0381 47.5867L40.6672 47.8993C41.2936 47.9533 41.7558 48.5101 41.6995 49.143C41.6433 49.776 41.0899 50.2453 40.4636 50.1914L36.8344 49.8788C36.2081 49.8248 35.7459 49.268 35.8021 48.635Z'
                fill='#00D1D2'
            />
            <path
                d='M36.5984 11.3807L47.486 12.3186L46.9114 13.9909C46.7055 14.5901 46.123 14.9727 45.4985 14.9189L38.0971 14.2813C37.4726 14.2275 36.9664 13.7512 36.8694 13.1259L36.5984 11.3807Z'
                fill='#FFFDFB'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M33.1716 34.979C33.211 34.536 33.5984 34.2074 34.037 34.2452L45.4717 35.2302C45.9103 35.268 46.2339 35.6578 46.1945 36.1008C46.1552 36.5438 45.7677 36.8723 45.3292 36.8346L33.8944 35.8496C33.4559 35.8118 33.1323 35.422 33.1716 34.979Z'
                fill='#FFFDFB'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M41.0019 20.5598C41.4404 20.5976 41.7641 20.9874 41.7247 21.4304L40.8167 31.6489C40.7773 32.0919 40.3899 32.4204 39.9513 32.3826C39.5128 32.3449 39.1892 31.9551 39.2285 31.5121L40.1365 21.2936C40.1759 20.8506 40.5633 20.5221 41.0019 20.5598Z'
                fill='#FFFDFB'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M35.6877 27.0526C36.0287 26.7698 36.531 26.8187 36.8095 27.1618L40.0678 31.1749L43.9843 27.7798C44.3191 27.4895 44.8224 27.5273 45.1083 27.8641C45.3943 28.2009 45.3546 28.7093 45.0198 28.9996L40.4836 32.9319C40.3205 33.0733 40.1082 33.1426 39.8946 33.1242C39.6809 33.1058 39.4841 33.0012 39.3484 32.8341L35.5746 28.186C35.2961 27.8429 35.3467 27.3354 35.6877 27.0526Z'
                fill='#FFFDFB'
            />
        </Icon>
    );
};

export default FirmwareUpdateIcon;
